<template>
  <v-container>
    <v-container class="text-center mt-2" v-if="loading">
      <v-progress-circular
        class="loading"
        indeterminate
        color="#881E98"
      ></v-progress-circular>
    </v-container>
    <v-container mt-5 class="details" v-else>
      <v-layout>
        <v-flex lg6 md12 offset-lg2 class="left-side">
          <v-card max-width="100%" outlined id="details-card">
            <v-list-item three-line id="environment-item-height">
              <v-list-item-content>
                <!-- details template name -->
                <div class="overline template-name">
                  {{ details.TemplateName }}
                </div>

                <!-- details environment name -->

                <v-list-item-title class="title">{{
                  details.EnvironmentName
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- details actions -->

            <v-card-actions>
              <v-container fluid>
                <v-layout wrap align-center class="card-actions">
                  <v-btn
                    class="action-button font-weight-bold"
                    text
                    @click="onShare"
                    :disabled="!details.AccessLevel && details.OwnerSub !== sub"
                  >
                    Share
                    <v-icon right id="icon-style">fal fa-share</v-icon>
                  </v-btn>
                  <Share
                    :showShareDialog.sync="showShareDialog"
                    :environmentId="environmentId"
                    :users="users"
                    :sharedEnvironmentWith="sharedEnvironmentWith"
                    @cancelShareDialog="cancelShareDialog"
                    @confirmShareDialog="confirmShareDialog"
                    :shareBtnloading="shareBtnloading"
                  />
                  <v-overlay :value="loadingModal">
                    <v-progress-circular
                      indeterminate
                      size="64"
                      class="progress-circular"
                    ></v-progress-circular>
                  </v-overlay>
                  <v-btn
                    v-if="details.TemplateType === 'VM'"
                    class="action-button font-weight-bold"
                    text
                    @click="
                      showCreateSnapshotDialog = !showCreateSnapshotDialog
                    "
                    :disabled="
                      (!details.AccessLevel && details.OwnerSub !== sub) ||
                      details.Status.toUpperCase() !== 'STOPPED' ||
                      details.Status.toUpperCase() === 'DURING_RESTORE' ||
                      details.SnapshotStatus.toUpperCase() === 'PENDING' ||
                      details.TemplateStatus.toUpperCase() === 'PENDING' ||
                      duringRestoring
                    "
                  >
                    Create Snapshot
                    <v-icon right id="icon-style">fas fa-camera</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="details.TemplateType === 'VM'"
                    class="action-button font-weight-bold"
                    text
                    @click="
                      showCreateTemplateDialog = !showCreateTemplateDialog
                    "
                    :disabled="
                      details.Status.toUpperCase() === 'DURING_RESTORE' ||
                      details.TemplateStatus.toUpperCase() === 'PENDING' ||
                      details.SnapshotStatus.toUpperCase() === 'PENDING' ||
                      details.Status.toUpperCase() !== 'STOPPED' ||
                      duringRestoring ||
                      blockCreateTemplateBtn
                    "
                  >
                    Create Template
                    <v-icon right id="icon-style">fas fa-plus-circle</v-icon>
                  </v-btn>

                  <v-btn
                    class="action-button font-weight-bold"
                    text
                    @click="showDeleteDialog = !showDeleteDialog"
                    :disabled="!details.AccessLevel && details.OwnerSub !== sub"
                  >
                    Delete
                    <v-icon right id="icon-style">fal fa-trash</v-icon>
                  </v-btn>
                </v-layout>
              </v-container>
            </v-card-actions>
          </v-card>

          <!-- tabs -->
          <v-tabs class="tabs" slider-color="#792D86" color="#121212">
            <v-tab key="details">Details</v-tab>
            <v-tab v-if="details.TemplateType === 'VM'" key="snapshots"
              >Snapshots</v-tab
            >
            <!-- TODO -->
            <v-tab-item key="details">
              <Details
                :details="details"
                :sharedEnvironmentWith="sharedEnvironmentWith"
                :sub="sub"
              />
            </v-tab-item>

            <v-tab-item key="snapshots">
              <Snapshots
                :environmentId="environmentId"
                :status="details.Status"
                :templateStatus="details.TemplateStatus"
                :snapshotStatus="details.SnapshotStatus"
                :isConnected="false"
              />
            </v-tab-item>
            <v-tab
              v-if="
                details.TemplateType === 'VM' &&
                (details.AccessLevel || details.OwnerSub === sub) &&
                details.OS === 'Linux'
              "
              key="ssh"
              >SSH</v-tab
            >
            <v-tab-item key="ssh">
              <EnvironmentSSH
                :details="details"
                :sshKeys="envSSHKeys"
                :userSSHKeys="userSSHKeys"
              ></EnvironmentSSH>
            </v-tab-item>
          </v-tabs>
        </v-flex>
        <v-flex lg2 md12 class="right-side">
          <DetailsCredentials
            :remoteEnvPassword="passwordRDP"
            :webAppPassword="password"
            :remoteEnvLogin="'Administrator'"
            :hiddenRemoteEnvPassword="hiddenRemoteEnvPassword"
            :hiddenWebPassword="hiddenWebPassword"
            :sub="sub"
            :details="details"
            @togglePassword="togglePassword"
            @copyPassword="copyPassword"
            @statusChange="statusChange"
            @openConnectDialog="openConnectDialog"
            @openWhitelistDialog="openWhitelistDialog"
          />
        </v-flex>
      </v-layout>

      <DeleteDialog
        :showDeleteDialog.sync="showDeleteDialog"
        :environmentId="environmentId"
        @confirmDeleteDialog="confirmDeleteDialog"
      />

      <CreateSnapshotDialog
        :showCreateSnapshotDialog.sync="showCreateSnapshotDialog"
        :environmentName="details.EnvironmentName"
        :status="details.Status"
        @confirmCreateSnapshotDialog="confirmCreateSnapshotDialog"
      />

      <CreateTemplateDialog
        :showCreateTemplateDialog.sync="showCreateTemplateDialog"
        :details="details"
        @confirmCreateTemplateDialog="confirmCreateTemplateDialog"
      />

      <ConnectDialog
        :showConnectDialog.sync="showConnectDialog"
        :keyPairName="details.KeyPairName"
        :FQDN="details.FQDN"
        :OSUsername="details.OSUsername"
        :details="details"
      />

      <WhitelistDialog
        v-if="details.AccessLevel || details.OwnerSub == sub"
        :showWhitelistDialog.sync="showWhitelistDialog"
        :environmentId="environmentId"
        :keyPairName="details.KeyPairName"
        :OS="details.OS"
      />
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Details from "./Tabs/Details";
import Snapshots from "./Tabs/Snapshots";
import DetailsCredentials from "./DetailsCredentials";
import Share from "../Share";
import DeleteDialog from "./DeleteDialog";
import CreateSnapshotDialog from "./CreateSnapshotDialog";
import CreateTemplateDialog from "./CreateTemplateDialog";
import ConnectDialog from "./ConnectDialog";
import WhitelistDialog from "./WhitelistDialog";
import EnvironmentSSH from "./Tabs/EnvironmentSSH";

export default {
  data() {
    return {
      loading: true,
      environmentId: null,
      showShareDialog: false,
      showDeleteDialog: false,
      showCreateSnapshotDialog: false,
      showCreateTemplateDialog: false,
      showConnectDialog: false,
      showWhitelistDialog: false,
      password: "********",
      passwordRDP: "********",
      hiddenRemoteEnvPassword: true,
      hiddenWebPassword: true,
      environment: {
        remoteEnvPassword: "testowanko",
        webAppPassword: "",
      },
      shareBtnloading: false,
      loadingModal: false,
      refreshInterval: "",
      envSSHKeys: [],
      userSSHKeys: [],
      blockCreateTemplateBtn: false,
    };
  },
  computed: {
    ...mapGetters([
      "details",
      "sub",
      "users",
      "sharedEnvironmentWith",
      "environmentSSHKeys",
      "SSHKeys",
      "duringRestoring",
    ]),
  },
  components: {
    Details,
    Snapshots,
    DetailsCredentials,
    Share,
    DeleteDialog,
    CreateSnapshotDialog,
    ConnectDialog,
    WhitelistDialog,
    EnvironmentSSH,
    CreateTemplateDialog,
  },
  watch: {
    "$route.params.id": function () {
      this.$nextTick();
    },
    environmentSSHKeys() {
      this.filterUserSSHKeys();
    },
  },
  methods: {
    ...mapActions([
      "showSnackbar",
      "getDetails",
      "deleteEnvironment",
      "createTemplate",
      "createSnapshot",
      "getUserSub",
      "getUsers",
      "getSharedEnvironmentWith",
      "shareEnvironment",
      "stopSharingEnvironment",
      "getEnvironmentSSHKeys",
      "getSSHKeys",
      "getSnapshots",
    ]),
    togglePassword(which) {
      if (which === "web") {
        this.hiddenWebPassword = !this.hiddenWebPassword;
        this.hiddenWebPassword
          ? (this.password = "********")
          : (this.password = this.details.ApplicationPassword);
      } else {
        this.hiddenRemoteEnvPassword = !this.hiddenRemoteEnvPassword;

        this.hiddenRemoteEnvPassword
          ? (this.passwordRDP = "********")
          : (this.passwordRDP = this.details.RdpPassword);
      }
    },
    copyPassword(which) {
      if (!this.hiddenRemoteEnvPassword || !this.hiddenWebPassword) {
        const textArea = document.createElement("textarea");
        textArea.value = which === "web" ? this.password : this.passwordRDP;
        document.body.appendChild(textArea);
        textArea.select();
        textArea.setSelectionRange(0, 9999999);
        document.execCommand("copy");
        textArea.remove();
        this.showSnackbar("Password has been copied!");
      }
    },
    testTooltipState(state) {
      console.log(state);
      this.showTooltip = false;
    },
    cancelDeleteDialog() {
      this.showDeleteDialog = false;
    },
    async confirmDeleteDialog() {
      this.loadingModal = true;
      const data = {
        environmentId: this.environmentId,
      };

      await this.deleteEnvironment(data);
      this.loadingModal = false;
      this.$router.push("/environments");
    },
    async confirmCreateSnapshotDialog(data) {
      const snapshot = {
        ...data,
        environmentId: this.$route.params.id,
      };

      await this.createSnapshot(snapshot);
      await this.getSnapshots(this.environmentId);
      this.showCreateSnapshotDialog = false;
    },
    cancelCreateSnapshotDialog() {
      this.showCreateSnapshotDialog = false;
    },
    async confirmCreateTemplateDialog(data) {
      console.log("CREATE TEMPLATE");
      this.blockCreateTemplateBtn = true;

      await this.createTemplate(data);

      this.showCreateTemplateDialog = false;
      setTimeout(async () => {
        await this.getDetails(data.environmentId);
        this.blockCreateTemplateBtn = false;
      }, 4000);
    },
    cancelCreateTemplateDialog() {
      this.showCreateTemplateDialog = false;
    },
    cancelShareDialog() {
      this.showShareDialog = false;
    },
    cancelConnectDialog() {
      this.showConnectDialog = false;
    },
    openConnectDialog() {
      this.showConnectDialog = true;
    },
    openWhitelistDialog() {
      this.showWhitelistDialog = true;
    },
    cancelWhitelistDialog() {
      this.showWhitelistDialog = false;
    },
    async confirmShareDialog(data) {
      this.shareBtnloading = true;
      if (data.addedMembers.length) {
        data.emails = data.addedMembers;
        const { addedMembers, removedMembers, ...params } = data;
        await this.shareEnvironment(params);
      }
      if (data.removedMembers.length) {
        data.emails = data.removedMembers;
        const { addedMembers, removedMembers, ...params } = data;
        await this.stopSharingEnvironment(params);
      }
      this.showShareDialog = false;
      this.shareBtnloading = false;
      await this.getSharedEnvironmentWith(this.environmentId);
    },
    async onShare() {
      this.loadingModal = true;
      await this.getUsers();
      this.loadingModal = false;
      this.showShareDialog = !this.showShareDialog;
    },
    async getPendingStates() {
      const pending =
        this.details.Status.toLowerCase() !== "running" &&
        this.details.Status.toLowerCase() !== "stopped";

      if (pending) {
        await this.getDetails(this.environmentId);
      } else {
        clearInterval(this.refreshInterval);
        this.refreshInterval = "";
      }
    },
    statusChange() {
      if (!this.refreshInterval)
        this.refreshInterval = setInterval(
          () => this.getPendingStates(),
          60 * 1000
        );
    },
    filterUserSSHKeys() {
      this.envSSHKeys = !this.details.AccessLevel
        ? this.environmentSSHKeys.filter((key) => key.UserSub === this.sub)
        : this.environmentSSHKeys;
      this.userSSHKeys = [];
      this.SSHKeys.forEach((userKey) => {
        const key = this.envSSHKeys.find(
          (envKey) => envKey.UserKeyId === userKey.Id
        );
        if (!key) this.userSSHKeys.push(userKey);
      });
    },
  },
  async beforeMount() {
    this.environmentId = this.$route.params.id;
    // await Promise.all([this.getDetails(this.environmentId), this.getUsers(), this.getSharedEnvironmentWith(this.environmentId)]);

    const { error, result } = await this.getDetails(this.environmentId);

    if (error || !result) {
      return this.$router.push("/environments");
    }

    await this.getSharedEnvironmentWith(this.environmentId);
    this.getUserSub();

    if (
      this.details.OS === "Linux" &&
      (this.details.AccessLevel || this.details.OwnerSub === this.sub)
    ) {
      await Promise.all([
        this.getEnvironmentSSHKeys(this.environmentId),
        this.getSSHKeys(),
      ]);
      this.filterUserSSHKeys();
    }

    this.loading = false;

    this.environment.remoteEnvPassword = this.details.RdpPassword;
    this.environment.webAppPassword = this.details.ApplicationPassword;

    this.refreshInterval = setInterval(
      () => this.getPendingStates(),
      60 * 1000
    );
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },
};
</script>

<style scoped>
.right-side {
  /* background: blue; */
  border-radius: 15px;
  position: sticky;
  height: 10%;
  margin-top: 10px;
  top: 100px;
  font-family: "Montserrat";
  box-shadow: 0px 0px 16px #00000014;
  text-align: center;
}

#details-card {
  border: 0;
}

#details-card .template-name {
  font-size: 0.9em !important;
  font-family: "Montserrat";
}

#details-card .title {
  font-weight: bold;
  font-family: "Montserrat" !important;
  font-size: 1.5em !important;
}

#details-card .title:before {
  position: absolute;
  bottom: 0px;
  content: "";
  width: 40px;
  border-bottom: 2px solid #6db42c;
}

.details .tabs {
  margin-top: 20px;
  border-bottom: 1px solid #e6e6e6;
  width: 95%;
  font-size: 1em;
}

.details {
  margin-top: 90px !important;
}

.loading {
  margin-top: 144px;
}

.progress-circular {
  z-index: 9999999999 !important;
}
</style>
